var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-video"},[_c('v-modal',{staticClass:"modal",attrs:{"showFooterCloseButton":false},on:{"close":function($event){return _vm.closeModal()}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('video',{attrs:{"id":"video","autoplay":"","controls":"","disablepictureinpicture":"","controlslist":"nodownload"},on:{"contextmenu":e => {
            e.preventDefault()
          }}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }